<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-row>
        <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
          <div class="title_page ma-3">
            <h4 class="breadcrumb_title_page">รายละเอียดทีมงาน</h4>
            <v-breadcrumbs :items="sub_menu">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>
          </div>
        </v-col>
        <v-col xs="12" sm="12" md="4" lg="2" xl="2" cols="12">
          <div class="title_page ma-3">
            <v-btn type="button" class="btn_back_page" elevation="4" @click="$router.back()" large>ย้อนกลับ</v-btn>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="mb-3" xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
          <v-card elevation="4" class="card_relative">
            <div class="tag_header_profile">
              <div class="grad-dark-brown-arin-bg pa-2 rounded-pill"
                style="box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);z-index: 1">
                <div class="logo_timeline mx-auto my-auto">
                  <img src="@/assets/arin_assets/store.png">
                </div>
              </div>
              <v-card elevation="3" class="card_title ml-n5">
                <div class="arin-text-color py-1 pl-8 pr-5">ข้อมูลทั่วไป</div>
              </v-card>
            </div>
            <v-row>
              <v-col xs="12" sm="12" md="4" lg="4" xl="4" cols="12">
                <center>
                  <div class="mt-4">
                    <v-img class="preview profile_img" :lazy-src="employeeDetailedit.emp_picture"
                      :src="employeeDetailedit.emp_picture" style="max-width:200px;max-height:200px;height: 200px;"></v-img>
                  </div>
                </center>
              </v-col>
              <v-col xs="12" sm="12" md="8" lg="8" xl="8" cols="12">
                <div class="profile_text">
                  <div class="profile_code_text">
                    <v-icon class="mr-3" color="#D6BFAF">mdi-account</v-icon>
                    <div class="py-1" style="font-size: 14px;color: #616A6B"><b>รหัสพนักงาน : {{
                      employeeDetailedit.em_code
                    }}</b></div>
                  </div>
                  <div class="d-flex justify-center mt-4">
                    <div class="mr-1 grey--text sub_title"><b>ชื่อ - สกุล :</b></div>
                    <div class="sub_title" style="color: #616A6B"><b>{{ employeeDetailedit.name }}</b></div>
                  </div>
                  <div class="d-flex justify-center mt-2">
                    <div class="mr-1 grey--text sub_title"><b>เบอร์โทร :</b></div>
                    <div class="sub_title" style="color: #616A6B"><b>{{ employeeDetailedit.tel }}</b></div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col class="mb-3" xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
          <v-card elevation="4" class="card_relative">
            <div class="tag_header_profile">
              <div class="grad-dark-brown-arin-bg pa-2 rounded-pill"
                style="box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);z-index: 1">
                <div class="logo_timeline mx-auto my-auto">
                  <img src="@/assets/arin_assets/store.png">
                </div>
              </div>
              <v-card elevation="3" class="card_title ml-n5">
                <div class="arin-text-color py-1 pl-8 pr-5">ข้อมูลธนาคาร</div>
              </v-card>
            </div>
            <v-row>
              <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                <div class="mt-4">
                  <v-img v-if="employeeDetailedit.bank_picture !== null" class="preview mx-auto my-auto" max-width="102"
                    :lazy-src="employeeDetailedit.bank_picture" :src="employeeDetailedit.bank_picture"></v-img>
                  <div class="text-center my-auto">
                    <div class="d-flex justify-center mt-4">
                      <div class="mr-1 grey--text sub_title"><b>ธนาคาร :</b></div>
                      <div class="sub_title" style="color: #616A6B"><b>{{ employeeDetailedit.bank_name }}</b></div>
                    </div>
                    <div class="d-flex justify-center mt-2">
                      <div class="mr-1 grey--text sub_title"><b>เลขที่บัญชี :</b></div>
                      <div class="sub_title" style="color: #616A6B"><b>{{ employeeDetailedit.bank_number }}</b></div>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col class="mb-3" xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
          <v-card elevation="4" class="card_relative mt-10">
            <div class="tag_header_profile">
              <div class="grad-dark-brown-arin-bg pa-2 rounded-pill"
                style="box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);z-index: 1">
                <div class="logo_timeline mx-auto my-auto">
                  <img src="@/assets/arin_assets/image-gallery.png">
                </div>
              </div>
              <v-card elevation="3" class="card_title ml-n5">
                <div class="arin-text-color py-1 pl-8 pr-5">ข้อมูลรูปภาพหลักฐาน</div>
              </v-card>
            </div>
            <v-row>
              <v-col class="text-center" xs="12" sm="12" md="12" lg="6" xl="6" cols="12">
                <div class="image_title">รูปภาพบัตรประชาชน</div>
                <div class="mt-4">
                  <v-img max-width="300"  :src="employeeDetailedit.id_care"
                    style="max-width:250px;max-height:250px;height: 250px;" class="communication_img mx-auto"></v-img>
                  <div class="text-center mt-6 mb-3">
                      <!-- <a :href="employeeDetailedit.id_care" download>ดาวน์โหลด</a> -->
                      <v-btn @click="downloadImage_other(employeeDetailedit.id_care_path)" type="bottom" height="45" class="white--text grad-success-arin-bg mobile_btn" download
                      id=""
                      style="font-size: 18px; border-radius: 10px;">ดาวน์โหลด</v-btn>
                  </div>
                </div>
              </v-col>

              <v-col class="text-center" xs="12" sm="12" md="12" lg="6" xl="6" cols="12">
                <div class="image_title">รูปภาพใบประกอบวิชาชีพ</div>
                <div class="mt-4">
                  <v-img max-width="300" :lazy-src="employeeDetailedit.pharmacycouncil"
                    :src="employeeDetailedit.pharmacycouncil" class="mx-auto"
                    style="max-width:250px;max-height:250px;height: 250px;"></v-img>
                  <div class="text-center mt-6 mb-3">
                    <!-- <a :href="employeeDetailedit.pharmacycouncil_path" download>
                    </a> -->

                      <v-btn @click="downloadImage_other(employeeDetailedit.pharmacycouncil_path)" type="bottom" height="45" class="white--text grad-success-arin-bg mobile_btn" download
                      style="font-size: 18px; border-radius: 10px;">ดาวน์โหลด</v-btn>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col class="mb-3" xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
          <v-card elevation="4" class="card_relative mt-10">
            <div class="tag_header_profile">
              <div class="grad-dark-brown-arin-bg pa-2 rounded-pill"
                style="box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);z-index: 1">
                <div class="logo_timeline mx-auto my-auto">
                  <img src="@/assets/arin_assets/padlock_white.png">
                </div>
              </div>
              <v-card elevation="3" class="card_title ml-n5">
                <div class="arin-text-color py-1 pl-8 pr-5">สิทธิ์การเข้าถึงข้อมูลภายในระบบ</div>
              </v-card>
            </div>
            <v-row class="mt-5" style="padding:15px">
              <v-col v-if="employeeDetailedit.claim_POS == 1 || employeeDetailedit.claim_status == 0" xs="12" sm="12"
                md="6" lg="3" xl="3" cols="12" class="px-7 title_page_center">
                การเข้าถึงการขาย
              </v-col>
              <v-col v-if="employeeDetailedit.claim_barcode == 1 || employeeDetailedit.claim_status == 0" xs="12" sm="12"
                md="6" lg="3" xl="3" cols="12" class="px-7 title_page_center">
                สิทธิ์การเข้าถึงการสร้างและพิมพ์บาร์โค้ด
              </v-col>
              <v-col v-if="employeeDetailedit.claim_cancelbill == 1 || employeeDetailedit.claim_status == 0" xs="12"
                sm="12" md="6" lg="3" xl="3" cols="12" class="px-7 title_page_center">
                สิทธิ์การยกเลิกบิล
              </v-col>
              <v-col v-if="employeeDetailedit.claim_report == 1 || employeeDetailedit.claim_status == 0" xs="12" sm="12"
                md="6" lg="3" xl="3" cols="12" class="px-7 title_page_center">
                สิทธิ์การเข้าหน้าดูรายงานร้าน
              </v-col>
              <v-col v-if="employeeDetailedit.claim_store == 1 || employeeDetailedit.claim_status == 0" xs="12" sm="12"
                md="6" lg="3" xl="3" cols="12" class="px-7 title_page_center">
                สิทธิ์การเข้าตั้งค่าร้านค้า
              </v-col>
              <v-col v-if="employeeDetailedit.claim_account == 1 || employeeDetailedit.claim_status == 0" xs="12" sm="12"
                md="6" lg="3" xl="3" cols="12" class="px-7 title_page_center">
                สิทธิ์การเข้าระบบบัญชี
              </v-col>
              <v-col v-if="employeeDetailedit.claim_promotion == 1 || employeeDetailedit.claim_status == 0" xs="12"
                sm="12" md="6" lg="3" xl="3" cols="12" class="px-7 title_page_center">
                สิทธิ์การเข้าถึงโปรโมชั่น
              </v-col>
              <v-col v-if="employeeDetailedit.claim_product == 1 || employeeDetailedit.claim_status == 0" xs="12" sm="12"
                md="6" lg="3" xl="3" cols="12" class="px-7 title_page_center">
                สิทธิ์การเข้าจัดการข้อมูลสินค้า
              </v-col>
              <v-col v-if="employeeDetailedit.claim_stock_report == 1 || employeeDetailedit.claim_status == 0" xs="12"
                sm="12" md="6" lg="3" xl="3" cols="12" class="px-7 title_page_center">
                สิทธิ์การเข้าดูรายงานคลัง
              </v-col>
              <v-col v-if="employeeDetailedit.claim_employee == 1 || employeeDetailedit.claim_status == 0" xs="12" sm="12"
                md="6" lg="3" xl="3" cols="12" class="px-7 title_page_center">
                สิทธิ์การเข้าจัดการพนักงาน
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import img_holder from "@/assets/arin_assets/image_sun_color.png";
import img_holder_bank from "@/assets/arin_assets/bankkok.png";
import img_holder_communication from "@/assets/arin_assets/card_communication.png";
import img_holder_certificate from "@/assets/arin_assets/image_certificate.png";
import { HTTP_ARIN } from "@/axios_arin";
import axios from 'axios';

export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Detail_employee",
  data() {
    return {
      loading_page: false,
      img_holder: img_holder,
      img_holder_bank: img_holder_bank,
      img_holder_communication: img_holder_communication,
      img_holder_certificate: img_holder_certificate,
      employeeDetailedit: [],
      sub_menu: [
        {
          text: 'ทีมงาน',
          disabled: false,
        },
        {
          text: 'รายละเอียดทีมงาน',
          disabled: false,
          href: '#',
        }
      ],
    }
  },
  methods: {
    downloadImage_other(path) {
      const imageUrl = path;
      const link = document.createElement("a");

      link.href = 'http://192.46.229.30:81/'+imageUrl;

      link.setAttribute("download", "");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    },
    // ฟังค์ชั่น การแสดงรายละเอียด
    getShow_api() {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
        }
      };
      HTTP_ARIN.get('/employee/showedit/' + this.$route.params.id, config).then((res) => {
        if (res.data.successful === true) {
          this.loading_page = false;
          console.log(res.data.employeeDetailedit);
          this.employeeDetailedit = res.data.employeeDetailedit;
        }
      })
    },
    downloadImage(imageLink) {
      const url = window.URL.createObjectURL(new Blob([imageLink]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', imageLink)
      document.body.appendChild(link)
      link.click()

      axios({
        url: imageLink,
        method: 'GET',
        responseType: 'blob'
      })
      .then(function (response) {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url

        const image = imageLink.split("/")
        const imageValue = image[image.length - 1]
        link.setAttribute('download', imageValue)
        document.body.appendChild(link)
        link.click()
      })
    }
  }, mounted() {
    this.getShow_api()
  }
}
</script>

<style scoped>
.title_page h4.breadcrumb_title_page {
  font-size: 20px !important;
}

.card_relative {
  position: relative;
  border-radius: 15px;
}

.profile_detail {
  display: grid;
  grid-template-columns: 30% 70%;
}

.header_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.communication_img {
  max-width: 350px;
}

.logo_timeline {
  width: 25px;
  height: 25px;
  padding: 0px;
}

.logo_timeline>img {
  max-width: 25px;
}

.tag_header_profile {
  display: flex;
  position: absolute;
  top: -30px;
  left: -5px;
}

.arin-text-color {
  color: #84611F;
  font-weight: 600;
  font-size: 18px;
}

.card_title {
  margin-top: 1px;
  margin-bottom: 1px;
  border-radius: 10px;
  border: 1px solid #D6BFAF;
}

.preview {
  border-radius: 10px;
}

.preview.profile_img {
  max-width: 172px;
  border-radius: 30px;
}

.content_flex {
  display: flex;
  justify-content: center;
}

.employee_box {
  border-radius: 10px;
  border: 1px solid #D6BFAF;
  width: auto;
}


.employee_code_main {
  display: flex;
  padding: 12px !important;
  border-radius: 10px;
  border: 1px solid #D6BFAF;
  width: 50%;
  justify-content: center;
}

.employee_code_text {
  font-size: 16px;
  color: #616A6B;
}

.profile_text {
  height: 90%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.profile_code_text {
  display: flex;
  justify-content: center;
  background: #FFFFFF;
  border: 1px solid #D6BFAF;
  border-radius: 10px;
  padding: 10px;
  width: 250px;
  margin: auto;
}

.sub_title {
  font-size: 16px;
}

.image_title {
  font-weight: 500;
  font-size: 16px;
}

.picture_details {
  display: grid;
  grid-template-columns: 40% 60%;
}

.mobile_btn {
  width: 40%;
}

.grid_four_ck {
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
}

@media only screen and (min-width: 0px)AND (max-width: 361px) {
  .arin-text-color {
    font-weight: 600;
    font-size: 14px;
  }

  .sub_title {
    font-size: 14px !important;
  }
}

@media only screen and (max-width: 600px) {
  .arin-text-color {
    font-weight: 600;
    font-size: 14px !important;
  }


  .title_page h4.breadcrumb_title_page,
  .v-tab,
  .sub_title {
    font-size: 14px !important;
  }

  .v-timeline-item__divider {
    display: none !important;
  }

}

@media only screen and (min-width: 601px) AND (max-width: 960px) {}

.arin-text-color {
  font-weight: 600;
  font-size: 16px !important;
}


@media only screen and (min-width: 961px) AND (max-width: 1264px) {}

@media only screen and (min-width: 1265px) AND (max-width: 1904px) {}
</style>
